import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {
  AnalyticsService,
  AngularDatasModule,
  AuthService,
  FxRateService,
  TourService,
  TRACKED_EVENTS,
} from '@univacity/angular/datas';
import { AngularUiModule, ScreenSizeService } from '@univacity/angular/ui';
import {
  COMMISSION_TYPE,
  FAVOURITE_TYPE,
  IMAGE_FORMAT,
  RoutePath,
  Tour,
  TOUR_STATUS,
} from '@univacity/shared/types';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { CardActionComponent } from '../../../components/card-action/card-action.component';
import { FavouriteIconComponent } from '../../../components/favourite-icon/favourite-icon.component';
import { ShareComponent } from '../../../components/share/share.component';
import { VideoPlayerComponent } from '../../../components/video-player/video-player.component';
import { TourHeaderPricingComponent } from '../tour-header-pricing/tour-header-pricing.component';
import { AnalyticsUtil } from '@univacity/shared/util';

@Component({
  selector: 'un-tour-header',
  imports: [
    CommonModule,
    AngularUiModule,
    FavouriteIconComponent,
    ShareComponent,
    NzBreadCrumbModule,
    AngularDatasModule,
    NzGridModule,
    RouterModule,
    NgOptimizedImage,
    CardActionComponent,
    VideoPlayerComponent,
    TourHeaderPricingComponent,
  ],
  templateUrl: './tour-header.component.html',
  styleUrls: ['./tour-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourHeaderComponent {
  @Input() tour: Tour;
  @Output() book = new EventEmitter<void>();
  showVideo = false;
  RoutePath = RoutePath;
  format = IMAGE_FORMAT.webp;
  favType = FAVOURITE_TYPE.tour;
  status = TOUR_STATUS;
  commType = COMMISSION_TYPE;

  constructor(
    public screen: ScreenSizeService,
    public auth: AuthService,
    public fx: FxRateService,
    public analytics: AnalyticsService,
    private svc: TourService,
    private router: Router
  ) {}

  bookTour() {
    this.analytics.track(TRACKED_EVENTS.tourBookClicked, {
      ...AnalyticsUtil.tour(this.tour),
      position: 'header',
    });
    this.book.emit();
  }

  delete() {
    this.svc
      .delete(this.tour._id)
      .subscribe(() => this.router.navigate([RoutePath.toursSearch]));
  }
}
